import Vue from 'vue';

// When the request succeeds
const success = (context, response) => {
  context.dynamicPriceSettings = response.dynamicPriceSettings;
  context.closeModal('#dynamic-price-modal');
  toastr.success(response.msg);
  context.smallLoading = false;
};

// When the request fails
const failed = (context, error) => {
  toastr.error(error);
  context.smallLoading = false;
};

export default (context, dynamicPriceSettings) => Vue.$http.post('/rentals/price-settings', dynamicPriceSettings)
        .then((response) => {
          if (response && response.status === 200) {
            success(context, response.data);
          } else {
            failed(context, response);
          }
        }).catch((error) => {
          if (error) {
            failed(context, error);
          }
        });



// WEBPACK FOOTER //
// ./src/app/services/rental/setDynamicPriceSettings.js